module.exports = __webpack_public_path__ + "static/img/qa01.a7fba50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qa01.png
// module id = RIWT
// module chunks = 1